export default __webpack_public_path__ + "static/APP_1_3-4d3163e6def38f6c7c8160250a31a711.png";